export const parseTitleFromHtml = (htmlString, lastCharInTitle = 50) => {
  // This function gets the HTML string value of the React Quill input as an argument and parses it into just its innerText and then slice that string if it is longer than 50 characters in order to create a name for the update for display purposes.

  let htmlForParsing = document.createElement('div')

  htmlForParsing.innerHTML = htmlString.trim()

  let formattedTitle = htmlForParsing.childNodes[0].innerText

  if (formattedTitle.length > 50 || htmlForParsing.childNodes.length > 1 ) {
    formattedTitle = `${formattedTitle.slice(0, lastCharInTitle)}...`
  }

  return formattedTitle
}



// WEBPACK FOOTER //
// ./src/functions/reactQuillHandling.js